export const zeroFill = (number, len) => {
    let zeros = '0'.repeat(len);
    let str = zeros + String(number);
    return str.slice(-len);
};
